const Footer = () => {
  return (
    <section className="Footer">
      <p></p>
    </section>
  );
};

export default Footer;
